import { useTranslation } from "react-i18next";
import { TbCheck } from "react-icons/tb";
import { CREATE_STEPS } from "./createSteps";
import type { CreateWizard } from "./useCreateWizard";

/**
 * Step bar. `full`: icon + label per step, with connectors. `compact`: small dots only — used in
 * the folded overview and on phones. Done steps (and the next open one) are buttons; the rest
 * are plain markers.
 */
export function CreateStepper({ wizard, compact = false }: { wizard: CreateWizard; compact?: boolean }) {
    const { t } = useTranslation();

    return (
        <ol className={`ic-stepper${compact ? " ic-stepper--compact" : ""}`} aria-label={t("invoiceCreate.stepsLabel")}>
            {CREATE_STEPS.map(({ key, Icon }, i) => {
                const state = wizard.stateOf(i);
                const label = t(`invoiceCreate.steps.${key}`);
                const clickable = state !== "current" && wizard.canOpen(i);
                const marker = (
                    <span className="ic-stepper__marker" aria-hidden>
                        {state === "done" ? <TbCheck /> : <Icon />}
                    </span>
                );
                return (
                    <li key={key} className={`ic-stepper__step ic-stepper__step--${state}`} aria-current={state === "current" ? "step" : undefined}>
                        {i > 0 && <span className="ic-stepper__connector" aria-hidden />}
                        {clickable ? (
                            <button type="button" className="ic-stepper__target" onClick={() => wizard.goTo(i)} title={label}>
                                {marker}
                                <span className="ic-stepper__label">{label}</span>
                            </button>
                        ) : (
                            <span className="ic-stepper__target" title={compact ? label : undefined}>
                                {marker}
                                <span className="ic-stepper__label">{label}</span>
                            </span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
